import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import TokenIcon from "components/toolbar/TokenIcon.js"

const ZNFTComponent = ({zobject}) => { 
    let {sequencerEngine} = zobject;
    return (
        <div className="z-nft">
          <TokenIcon seedHash={sequencerEngine.seedHash}/>
          NFT
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZNFTComponent);
